import React from 'react';
import InternalLink from 'react-router-dom/Link';

export default class extends React.Component {
  static propTypes = InternalLink.propTypes;
  render() {
    const { external, to } = this.props;
    if (typeof to === 'string' && (external || /http(s)?:\/\//.test(to))) {
      // eslint-disable-next-line jsx-a11y/anchor-has-content
      return <a href={to} {...this.props} />;
    }
    return <InternalLink {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Link/index.js